export default build =>
    build.query({
        tagTypes: ['allDistricts'],
        keepUnusedDataFor: 30,
        query() {
            //console.log("payload",payload)            
            return {
                url: '/exam/getdistrict',
                method: 'GET',
               // body: payload,
            };
           
        },
       providesTags: ['allDistricts']
    })
